import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-4 sm:pt-8 pb-16 px-4 overflow-hidden bg-brand-base relative" data-id="element-173">
      {/* glows */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-brand-purple/30 rounded-full blur-[120px] pointer-events-none" data-id="element-174"></div>
      <div className="absolute top-2/3 left-1/4 w-[300px] h-[300px] bg-brand-gold/15 rounded-full blur-[100px] pointer-events-none" data-id="element-175"></div>
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[300px] h-[100px] bg-brand-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-176"></div>

      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 sm:px-4 sm:py-2 rounded-full bg-white/5 border border-white/10 text-brand-green font-semibold text-xs sm:text-sm mb-3 sm:mb-6 backdrop-blur-sm" data-id="element-178">
          <span data-id="element-179">🌸</span> IMPULSO DIGITAL STORE™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-2 text-white text-[32px]" data-id="element-180">
          Todo tu negocio de frasquitos.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-xl sm:text-3xl lg:text-4xl font-extrabold text-brand-green mb-4 sm:mb-6 leading-tight" data-id="element-181">
          Listo. Desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative w-full max-w-[240px] sm:max-w-md lg:max-w-lg mb-4 sm:mb-6" data-id="element-182">
          <div className="absolute inset-0 bg-brand-green/20 rounded-full blur-3xl scale-90 pointer-events-none" data-id="element-183"></div>
          <img src="https://cdn.magicpatterns.com/uploads/q2NKZ4XsC477sHYuFDKXbw/png.png" alt="Megapack Emprende con Dios" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-184" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-sm sm:text-xl font-bold mb-2 tracking-wide text-brand-green" data-id="element-185">
          MEGAPACK EMPRENDE CON DIOS™
        </motion.h2>

        <p className="text-gray-300 mb-3 sm:mb-6 max-w-2xl text-[13px] sm:text-base leading-snug" data-id="element-186">
          El sistema N°1 para emprendedoras cristianas en Argentina. Fabricá ·
          Presentá · Vendé · Escalá
        </p>

        {/* Feature pills — single line, outlined green, no fill */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="w-full mb-4 sm:mb-5" data-id="element-187">
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 flex-nowrap mx-auto" data-id="element-188">
            <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-1 sm:px-3 sm:py-1.5 rounded-full border border-brand-green text-white text-[10px] sm:text-xs font-bold" data-id="element-189">
              <span data-id="element-190">📄</span> 100% PDF
            </span>
            <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-1 sm:px-3 sm:py-1.5 rounded-full border border-brand-green text-white text-[10px] sm:text-xs font-bold" data-id="element-191">
              <span data-id="element-192">⚡</span> 5 min
            </span>
            <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-1 sm:px-3 sm:py-1.5 rounded-full border border-brand-green text-white text-[10px] sm:text-xs font-bold" data-id="element-193">
              <span data-id="element-194">🇦🇷</span> Argentina
            </span>
            <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-1 sm:px-3 sm:py-1.5 rounded-full border border-brand-green text-white text-[10px] sm:text-xs font-bold" data-id="element-195">
              <span data-id="element-196">🌸</span> 6 Tomos
            </span>
          </div>
        </motion.div>

        <div className="relative inline-block mb-6 sm:mb-8" data-id="element-197">
          <div className="absolute -inset-4 bg-brand-purple/40 blur-2xl rounded-full -z-10 pointer-events-none" data-id="element-198"></div>
          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} onClick={scrollToPricing} className="bg-brand-green text-white font-bold text-base sm:text-lg py-3.5 px-8 sm:py-4 sm:px-10 rounded-xl shadow-[0_8px_30px_rgba(74,27,109,0.4)] hover:shadow-[0_10px_40px_rgba(74,27,109,0.6)] transition-all relative z-10" data-id="element-199">
            🌸 QUIERO MI MEGAPACK AHORA
          </motion.button>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-x-3 sm:gap-x-6 text-[11px] sm:text-sm font-medium text-gray-400 mb-8 whitespace-nowrap" data-id="element-200">
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-201">
            <Shield size={14} className="text-brand-green shrink-0 sm:size-4" data-id="element-202" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-203">
            <Lock size={14} className="text-brand-green shrink-0 sm:size-4" data-id="element-204" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-205">
            <CreditCard size={14} className="text-brand-green shrink-0 sm:size-4" data-id="element-206" />{' '}
            Mercado Pago
          </span>
        </div>

        <div className="w-full max-w-md h-px bg-white/10 mb-6" data-id="element-207"></div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-6 w-full max-w-xs sm:max-w-sm py-2" data-id="element-208">
          <div className="flex flex-col items-center text-center" data-id="element-209">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-210">
              +500
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-green" data-id="element-211">
              emprendedoras ya empezaron
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-212">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-213">
              6
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-green" data-id="element-214">
              Tomos listos
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-215">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-216">
              6
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-green" data-id="element-217">
              Bonos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-218">
            <span className="text-2xl sm:text-3xl font-extrabold text-white leading-none mb-1" data-id="element-219">
              4.9/5
            </span>
            <span className="text-xs sm:text-sm font-bold text-brand-green inline-flex items-center gap-1" data-id="element-220">
              calificación <span aria-hidden data-id="element-221">⭐</span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}